import { Box, Text, Image, Flex, Stack } from '@chakra-ui/core'
import React from 'react'
import { Maybe, TaskEntity } from '../../../../generated/graphql'
import { images } from '../../../../theme'
import DataFieldsDetailsGenerator from './DataFieldsDetailsGenerator'
import { StatusBadge } from '../../../../components'

type EvidenceDetailsProps = {
  task?: Maybe<TaskEntity>
}

const EvidenceDetails: React.FC<EvidenceDetailsProps> = ({ task }) => {
  const evidence = task?.attributes?.evidences?.data?.[0]
  const dataFields = evidence?.attributes?.custom_data_fields
  const photoEvidences = task?.attributes?.evidences?.data?.[0]?.attributes?.photos?.data

  return (
    <Box>
      <Stack mb={4} spacing={2} direction="row" alignItems="flex-end">
        <Text fontSize="xs">Task {task?.id} is</Text>
        <StatusBadge display="inline" fontSize="xs" status={task?.attributes?.status} mx={1} />
      </Stack>
      <Flex my={4} alignItems="center">
        {photoEvidences?.map((photo) => (
          <Image
            key={photo.id}
            src={
              photo.attributes?.formats?.thumbnail?.url ||
              photo.attributes?.url ||
              images.baotreeLogo
            }
            alt="Evidence"
            w={24}
            h={24}
            objectFit="cover"
            rounded="lg"
            mr={2}
          />
        ))}
      </Flex>
      <DataFieldsDetailsGenerator dataFields={dataFields} />
    </Box>
  )
}

export default EvidenceDetails
